import httpClient from '../../utils/httpClient';
import { cleanPhoneCategory, formatDate } from '../../utils/profileHelpers';
import css from '../../../../css/css-variables';
import { PERMISSIONS } from '../../constants';

export const DEFAULT_PAGE_SIZE = 100;


/* GET User Profile */
export async function getProfileData() {
  try {
    const response = await httpClient().get('/profile');
    const { data } = response;

    const person = data.person;
    const username = data.emails?.find((email) => email.isUsername)
      ?.emailAddress;
    const user = {
      ...person,
      initials: person?.firstName?.length && person.firstName.charAt(0),
      fullName:
        person?.firstName &&
        person?.lastName &&
        `${person.firstName} ${person.lastName}`,
      initialsColor: css.colors.DarkGray,
      phones: data.phones
        ? data.phones.map((phone) =>
            cleanPhoneCategory(phone, ['HOME', 'MOBILE', 'WORK'])
          )
        : [],
      emailAddress: username || '[PLEASE UPDATE YOUR EMAIL ADDRESS]',
      addresses: data.addresses || [],
      birthDate: person?.birthDate && formatDate(person?.birthDate),
    };

    return user;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
}

export async function getCustomerProfileData() {
  try {
    const response = await httpClient().get('/customer-profile');
    const { data } = response;

    const customer = data;

    return customer;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
}

export async function addMinistryFocusLogic({ type, customDescription }) {
  try {
    const response = await httpClient().post('/add-ministry-focus', {
      type,
      customDescription,
    });

    if (response?.status !== 200) {
      throw new Error('Network response was not ok', response);
    }

    return await response;
  } catch (error) {
    console.error('Error adding ministry focus:', error);
    throw error;
  }
}

/* Get Customer Permissions */
const createPermissionObject = (permissionId, organizationId, account) => {
  const permissionObject = {
    permissionId,
    permissionScope: {
      organization: organizationId,
    },
  };

  if (account) {
    permissionObject.permissionScope['account'] = account;
  }

  return permissionObject;
};

const getCustomerPermissionsPayload = (orgs, customerId) => {
  const permissionArray = orgs.flatMap((org) =>
    PERMISSIONS.map((permission) => {
      const permissionsWithAccountNumbers = [
        'PayWithACH',
        'ViewTransactionHistory',
        'ManageACHPaymentMethods',
      ];

      if (
        permissionsWithAccountNumbers.includes(permission.displayId) &&
        org?.organizationProfile.billingAccounts
      ) {
        return org?.organizationProfile.billingAccounts
          .map((account) =>
            createPermissionObject(
              permission.permissionId,
              org.organizationId,
              account.accountNumber
            )
          )
          .flat();
      }

      return createPermissionObject(
        permission.permissionId,
        org.organizationId
      );
    })
  );

  return {
    customerId,
    queryPermissions: permissionArray.flat(),
  };
};

const getPermissions = async (
  action,
  page = 0,
  pageSize = DEFAULT_PAGE_SIZE
) => {
  const { data: permissions } = await action({ page, pageSize });
  if (permissions.content && page < permissions.totalPages - 1) {
    const nextPageData = await getPermissions(action, page + 1, pageSize);
    return [...permissions?.content, ...nextPageData];
  }
  return permissions.content;
};

export const getCustomerPermissions = async (customerId, linkedOrgs) => {
  const customerPermissions = getCustomerPermissionsPayload(
    linkedOrgs,
    customerId
  );
  const permissionCall = (params) =>
    httpClient().post(
      `/organization/customer/permissions?page=${params?.page}&size=${params?.pageSize}`,
      {
        ...customerPermissions,
      }
    );

  return await getPermissions(permissionCall);
};
